import { NotificationService } from './../../_services/notification.service';
import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'iq-central-front-end-app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  stompClient: any;
  userId: any;
  notifications: any[] = [];

  constructor(
    private _notification: NotificationService,
    private _toastr: ToastrService
  ) {}

  ngOnInit() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.userId = userDetails['user_id'];
    this.openConnection();
  }
  openConnection() {
    // Open connection with server socket
    this.stompClient = this._notification.connect();
    const that = this;
    this.stompClient.connect({}, frame => {
      that.openNotificationSocket();
    });
  }

  openNotificationSocket() {
    this.stompClient.subscribe(
      '/topic/notifications/user/' + this.userId,
      notifications => {
        console.log(notifications.body);
        this.handleResult(notifications);
      }
    );
  }

  // openMessageSocket() {
  //   this.stompClient.subscribe(
  //     '/topic/messages/user/' + this.userId,
  //     notifications => {
  //       console.log(notifications.body);
  //       this.handleResult(notifications);
  //     }
  //   );
  // }

  handleResult(notification) {
    if (notification.body) {
      const notificationResult = notification.body;
      this.notifications.push(notificationResult);
      this._toastr.success('new notification recieved', notificationResult, {
        timeOut: 5000
      });
      this.playAudio();
    }
  }
  playAudio() {
    const audio = new Audio();
    audio.src = 'assets/sounds/notification.mp3';
    audio.load();
    audio.play();
  }
}
